import React from 'react'
import imgLoging from '../../assets/img/79609-loading-button.gif'

const LoadingContenido = () => {
    return <div className='loading_component'><img src={imgLoging} alt='login...' /></div>
}

export default LoadingContenido
